<template>		
	<div>		
		<div v-if="!props.pedido.cancelado" :class="deliveryStatus(props.pedido).style" class="rounded-full text-center py-1 px-2">
			<p class="whitespace-nowrap">{{ deliveryStatus(props.pedido).label }}</p>
		</div>
	</div>
</template>

<script>
	import { getOrderDeliveryState } from '../utils/recolecciones.js'

	export default {
		props: ['pedido'],

		setup(props) {
			const deliveryStatuses = {
				complete: { label: 'Entregado', style: 'border border-primary text-primary' },
				pending: { label: 'En camino', style: 'border border-yellow-500 text-yellow-500' },
				evidence_pending: { label: 'Evidencia pendiente', style: 'border border-yellow-500 text-yellow-500' },
				failed: { label: 'Fallido', style: 'border border-red text-red' },
				not_started: { label: 'Pendiente', style: 'border border-yellow-500 text-yellow-500' },
			}

			function deliveryStatus(pedido) {
				if (!pedido.require_entrega) {
					return { label: 'No requiere', style: 'border text-gray-300 border-gray-300' }
				}
				return deliveryStatuses[getOrderDeliveryState(pedido)]
			}

			return {
				props,
				deliveryStatus,
			}
		}
	}
</script>
